export default __webpack_public_path__ + "static/media/foodGreen.2f59cfd4.png";